import { Button } from '@mui/material';
import { useOktaAuth } from '@okta/okta-react';
import Footer from './MainContainer/Footer';
import StoneXLogo from '../Assets/StoneX_Dark.svg';
import KnowRiskLogo from '../Assets/KnowRisk_Dark.svg';

export default function LoginPage() {
  const { oktaAuth } = useOktaAuth();

  const login = async () => oktaAuth.signInWithRedirect();

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', background: 'linear-gradient(to bottom, #f8f9fa 0%,rgb(217, 217, 217) 100%)' }}>
      <div style={{ 
        display: 'flex', 
        flexGrow: 1,
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '50px',
          alignItems: 'center'
        }}>
          {/* Top section with logo and button */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            width: '100%',
            gap: '250px'
          }}>
            <div>
              <img src={StoneXLogo} alt="StoneX Logo" style={{ maxWidth: '300px' }} />
              <img src={KnowRiskLogo} alt="KnowRisk Logo" style={{ maxWidth: '250px', marginTop: '30px' }} />
            </div>
            <Button 
              variant="contained" 
              onClick={login} 
              sx={{
                backgroundPosition: 'left center',
                background: 'linear-gradient(107deg, #0d1775 0%, #1383f4 50%, #0d1775 100%)',
                padding: '25px',
                minWidth: '200px',
                fontSize: '16px',
                fontWeight: 'bold',
                backgroundSize: '200% 100%',
                transition: 'background-position 0.5s, text-shadow 0.3s',
                '&:hover': {
                  textShadow: '0px 0px 8px #ffffff, 0 0 16px #fff',
                  backgroundPosition: 'right center',
                }
              }}
            >
              Client Login
            </Button>
          </div>

          {/* Bottom section with text */}
          <div style={{ textAlign: 'left', color: '#666', width: '100%' }}>
            <h2>Welcome to KnowRisk</h2>
            <p>Access your risk management dashboard and analytics tools.</p>
            <Button 
              variant='text' 
              style={{fontSize: '16px', fontWeight: 500, padding: '10px', marginLeft: '-10px'}} 
              onClick={() => window.open('https://www.stonex.com', '_blank')}>
              Learn more about StoneX
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
